import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  public url: string = `${environment.baseUrl}admin`;

  constructor(private http: HttpClient) { }

  private getHttpOptions() {
    const authToken = sessionStorage.getItem("auth_token");
    return {
      headers: new HttpHeaders({
        Authorization: authToken || '',
        'user_type': '1'
      }),
    };
  }

  // Referral Code Management
  getReferralCodes(pageNumber: number, sortKey: string, sortDirection: string, searchquery: string): Observable<any> {
    let queryParams = `page=${pageNumber}&limit=10&sortKey=${sortKey}&sortDirection=${sortDirection}`;
    if (searchquery && searchquery.trim() !== '') {
      queryParams += `&search_query=${encodeURIComponent(searchquery.trim())}`;
    }
    return this.http.get<any>(
      `${this.url}/referral-codes?${queryParams}`,
      this.getHttpOptions()
    );
  }

  // View Code API (GET - get single referral code by ID)
  getReferralCodeById(codeId: string): Observable<any> {
    console.log('View Code API URL:', `${this.url}/referrals/codes/${codeId}`);
    return this.http.get<any>(`${this.url}/referrals/codes/${codeId}`, this.getHttpOptions());
  }

  // Generate Code API (GET - auto-generate code)
  generateReferralCodeAuto(): Observable<any> {
    console.log('Generate Code API URL:', `${this.url}/referrals/codes/generate`);
    return this.http.get<any>(`${this.url}/referrals/codes/generate`, this.getHttpOptions());
  }

  // Create Code API (POST - create code with data)
  generateReferralCode(data: { referral_code: string, user_id?: string, reward_amount?: number, expiry_date?: string, max_uses?: number }): Observable<any> {
    debugger
    console.log('API URL:', `${this.url}/referrals/codes/create`);
    console.log('Request Data:', data);
    return this.http.post<any>(`${this.url}/referrals/codes/create`, data, this.getHttpOptions());
  }

  // Update Code API (PUT - update referral code)
  updateReferralCode(id: string, data: any): Observable<any> {
    console.log('Update Code API URL:', `${this.url}/referrals/codes/${id}`);
    console.log('Update Data:', data);
    return this.http.put<any>(`${this.url}/referrals/codes/${id}`, data, this.getHttpOptions());
  }

  // Delete Code API (DELETE - delete referral code)
  deleteReferralCode(id: string): Observable<any> {
    const apiUrl = `${this.url}/referrals/codes/${id}`;
    console.log('Delete Code API URL:', apiUrl);
    console.log('Delete Code ID:', id);
    const httpOptions = this.getHttpOptions();
    console.log('Delete HTTP Options:', httpOptions);
    return this.http.delete<any>(apiUrl, httpOptions);
  }

  // Toggle Status API (PUT - update referral code status)
  activateDeactivateReferralCode(id: string, status: string): Observable<any> {
    console.log('Toggle Status API URL:', `${this.url}/referrals/codes/${id}/status`);
    console.log('Status:', status);
    return this.http.put<any>(`${this.url}/referrals/codes/${id}/status`, { status }, this.getHttpOptions());
  }

 // Referral Tracking
getReferralTracking(
  pageNumber: number = 1,
  limit: number = 10,
  status?: string,
  search?: string,
  type?: string
): Observable<any> {

  let queryParams = `page=${pageNumber}&limit=${limit}`;

  if (status && status.trim() !== '' && status !== 'All Status') {
    queryParams += `&status=${encodeURIComponent(status.trim())}`;
  }

  if (search && search.trim() !== '') {
    queryParams += `&search=${encodeURIComponent(search.trim())}`;
  }

  if (type && type.trim() !== '') {
    queryParams += `&type=${encodeURIComponent(type.trim())}`;
  }

  return this.http.get<any>(
    `${this.url}/reward-tracing/all?${queryParams}`,
    this.getHttpOptions()
  );
}


  getReferralDetails(id: string): Observable<any> {
    return this.http.get<any>(`${this.url}/referral-tracking/${id}`, this.getHttpOptions());
  }

  // Referral Rewards
  getReferralRewards(pageNumber: number, limit: number = 10, rewardStatus?: string, referralStatus?: string): Observable<any> {
    let queryParams = `page=${pageNumber}&limit=${limit}`;
    
    if (rewardStatus && rewardStatus.trim() !== '') {
      queryParams += `&reward_status=${encodeURIComponent(rewardStatus.trim())}`;
    }
    
    if (referralStatus && referralStatus.trim() !== '') {
      queryParams += `&status=${encodeURIComponent(referralStatus.trim())}`;
    }
    
    return this.http.get<any>(
      `${this.url}/referrals/rewards?${queryParams}`,
      this.getHttpOptions()
    );
  }

  // Get Referral Settings (GET /referrals/settings)
  getReferralSettings(): Observable<any> {
    return this.http.get<any>(`${this.url}/referrals/settings`, this.getHttpOptions());
  }

  // Update Referral Settings (PUT /referrals/settings)
  updateReferralSettings(data: { referrer_reward_amount: number, referred_reward_amount: number }): Observable<any> {
    return this.http.put<any>(`${this.url}/referrals/settings`, data, this.getHttpOptions());
  }

  updateRewardSettings(data: { reward_type: string, reward_amount: number, reward_percentage?: number }): Observable<any> {
    return this.http.post<any>(`${this.url}/referral-rewards/settings`, data, this.getHttpOptions());
  }

  processReward(referralId: string, data: { action: string, amount?: number }): Observable<any> {
    return this.http.post<any>(`${this.url}/referral-rewards/process/${referralId}`, data, this.getHttpOptions());
  }

  // Fraud Check
  getFraudChecks(pageNumber: number, limit: number = 10): Observable<any> {
    const apiUrl = `${this.url}/referrals/fraud?page=${pageNumber}&limit=${limit}`;
    console.log('Fraud Check API URL:', apiUrl);
    return this.http.get<any>(apiUrl, this.getHttpOptions());
  }

  markAsFraud(referralId: string, reason: string): Observable<any> {
    return this.http.post<any>(`${this.url}/referral-fraud-checks/mark-fraud`, { referral_id: referralId, reason }, this.getHttpOptions());
  }

  approveReferral(referralId: string): Observable<any> {
    return this.http.post<any>(`${this.url}/referral-fraud-checks/approve/${referralId}`, {}, this.getHttpOptions());
  }

  // Reports & Analytics
  getReferralReports(filters: { start_date?: string, end_date?: string, code_id?: string, user_id?: string }): Observable<any> {
    let queryParams = '';
    if (filters.start_date) queryParams += `&start_date=${filters.start_date}`;
    if (filters.end_date) queryParams += `&end_date=${filters.end_date}`;
    if (filters.code_id) queryParams += `&code_id=${filters.code_id}`;
    if (filters.user_id) queryParams += `&user_id=${filters.user_id}`;
    
    return this.http.get<any>(`${this.url}/referral-reports?${queryParams}`, this.getHttpOptions());
  }

  getReferralAnalytics(startDate?: string, endDate?: string): Observable<any> {
    let queryParams = '';
    if (startDate) queryParams += `start_date=${startDate}`;
    if (endDate) {
      if (queryParams) queryParams += '&';
      queryParams += `end_date=${endDate}`;
    }
    
    const url = queryParams ? `${this.url}/referrals/analytics?${queryParams}` : `${this.url}/referrals/analytics`;
    console.log('Analytics API URL:', url);
    return this.http.get<any>(url, this.getHttpOptions());
  }

  private parseBoolean(value: any): boolean | null {
    if (typeof value === 'boolean') {
      return value;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      if (normalized === 'true' || normalized === '1') {
        return true;
      }
      if (normalized === 'false' || normalized === '0') {
        return false;
      }
    }
    if (typeof value === 'number') {
      return value === 1;
    }
    return null;
  }

  private normalizeToggleResponse(response: any): { customer: boolean; partner: boolean } {
    const customer = this.parseBoolean(response.customer ?? response.data?.customer ?? response.payload?.customer ?? response.result?.customer ?? response.status) ?? false;
    const partner = this.parseBoolean(response.partner ?? response.data?.partner ?? response.payload?.partner ?? response.result?.partner ?? response.buttonStatus) ?? false;
    return { customer, partner };
  }

  // Referral Program Toggle
  getReferralToggleStatus(): Observable<any> {
    console.log('Getting referral toggle status from:', `${this.url}/toggle-button`);
    return this.http.get<any>(`${this.url}/toggle-button`, this.getHttpOptions())
      .pipe(
        timeout(5000),
        map((response) => {
          console.log('Referral toggle GET response:', response);
          return this.normalizeToggleResponse(response);
        }),
        catchError((err) => {
          console.error('Failed to load referral toggle status', err);
          return throwError(err);
        })
      );
  }

  toggleReferralStatus(type: 'customer' | 'partner', status: boolean): Observable<any> {
    console.log('Toggling referral status:', type, status);
    console.log('Posting to:', `${this.url}/toggle-button`);
    return this.http.post<any>(`${this.url}/toggle-button`, { type, status }, this.getHttpOptions())
      .pipe(
        timeout(5000),
        map((response) => {
          console.log('Referral toggle POST response:', response);
          return this.normalizeToggleResponse(response);
        }),
        catchError((err) => {
          console.error('Failed to toggle referral status', err);
          return throwError(err);
        })
      );
  }
}

